import { render, staticRenderFns } from "./CalendarPane.vue?vue&type=template&id=6d1b2fb3&scoped=true"
import script from "./CalendarPane.vue?vue&type=script&lang=ts"
export * from "./CalendarPane.vue?vue&type=script&lang=ts"
import style0 from "./CalendarPane.vue?vue&type=style&index=0&id=6d1b2fb3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1b2fb3",
  null
  
)

export default component.exports